import script from "./MapBox.vue?vue&type=script&setup=true&lang=js"
export * from "./MapBox.vue?vue&type=script&setup=true&lang=js"

import "./MapBox.vue?vue&type=style&index=0&id=3290cb3c&scoped=true&lang=css"

import exportComponent from "/home/tml/work/WP-plugins/wpaprsdb/wpaprsdb/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3290cb3c"]])

export default __exports__